export const DEFAULT_DOWNLOAD_EXTENSIONS: readonly string[] = [
  'pdf', 'zip', 'dmg', 'xlsx', 'csv', 'doc', 'docx', 'ppt', 'pptx',
  'rar', '7z', 'gz', 'mp3', 'mp4', 'wav', 'avi', 'mov',
  'exe', 'apk', 'mkv', 'txt',
]
